import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import validateAttachment from "MODULES/Receiving/components/shared/FormSections/validate";
import {
  ATTACHMENTS,
  CARRIER,
  CONTACT_EMAIL,
  QUANTITY,
  SHIPPING_METHOD
} from "APP_ROOT/constants";
import { HEIGHT, LENGTH, WEIGHT, WIDTH } from "MODULES/parts/constants";
import { OUTGOING_AWB_NUMBER } from "MODULES/Shipping/constants";

export default function(values, props) {
  if (values.picking) {
    return validator(values, () => null);
  }

  return validator(values, form => {
    if (!props.shippingRecord.received_virtually) {
      form.validate(WEIGHT, LENGTH, WIDTH, HEIGHT).satisfies(rules.required);

      if (
        values.ship_multiple_item_ids &&
        values.ship_multiple_item_ids.length === 1
      ) {
        form.validate(QUANTITY).satisfies(rules.required);
      } else if (!values.ship_multiple_item_ids) {
        form.validate(QUANTITY).satisfies(rules.required);
      }
    }

    form.validate(OUTGOING_AWB_NUMBER).satisfies(rules.required);
    form.validate(CONTACT_EMAIL).satisfies(rules.isValidEmail);
    form.validateChildren(ATTACHMENTS, validateAttachment);

    if (props.isIto) return;
    form.validateChild(SHIPPING_METHOD, method => {
      method.validate(CARRIER, SHIPPING_METHOD).satisfies(rules.required);
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/Create/validate.js